//import {axiosClient} from '../../main'
import Vue from 'vue'
import _ from 'lodash'
//import axios from '../../http/axios/index.js'

export default {
  addProduct ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      const product = new FormData()
      product.append('name', obj.name)
      product.append('category', obj.category)
      product.append('priceAmount', obj.priceAmount)
      product.append('pid', obj.pid)
      product.append('brand', obj.brand)
      product.append('contents', obj.contents)
      product.append('description', obj.description)
      product.append('features', obj.features)
      product.append('moduleLevel', obj.moduleLevel)
      product.append('tags', obj.tags)
      product.append('type', obj.type)
      _.forEach(obj.files, file => {
        product.append('files', file)
      })
      
      if (obj.courses) {
        _.forEach(obj.courses, course => {
          product.append('courses', course)
          // console.log('file generated', file)
        })
      } 

      Vue.prototype.$http.post('/products/add/', product)
        .then((response) => {
          commit('ADD_PRODUCT', Object.assign(response.data.data[0]))
          // console.log('created product', response.data.data[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchProducts ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/products')
        .then((response) => {
          commit('SET_PRODUCTS', response.data.data.products)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateProduct ({ dispatch }, obj) {
    return new Promise((resolve, reject) => {
      const product = new FormData()
      product.append('name', obj.name)
      product.append('category', obj.category)
      product.append('priceAmount', obj.priceAmount)
      product.append('pid', obj.pid)
      product.append('brand', obj.brand)
      product.append('contents', obj.contents)
      product.append('description', obj.description)
      product.append('features', obj.features)
      product.append('moduleLevel', obj.moduleLevel)
      product.append('tags', obj.tags)
      product.append('type', obj.type)
      // product.append('courses', obj.courses)
      if (obj.files) {
        _.forEach(obj.files, file => {
          product.append('files', file)
          // console.log('file generated', file)
        })
      } 
      if (obj.allImgUrls) {
        _.forEach(obj.allImgUrls, file => {
          product.append('imageJson', JSON.stringify(file))
          // console.log('esixting urls stringified')
        })
      }
      if (obj.courses) {
        _.forEach(obj.courses, course => {
          product.append('courses', course)
          // console.log('file generated', file)
        })
      } 
      
      // console.log('line 70 form data of product', ...product)
          
      Vue.prototype.$http.put(`/products/update/${obj.id}`, product)
        .then((response) => {
          //commit('UPDATE_PRODUCT', response.data.data.products)
          dispatch('fetchProducts')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeProduct ({ commit }, productId) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.delete(`/products/remove/${productId}`)
        .then((response) => {
          commit('REMOVE_PRODUCT', productId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateInventry ({ dispatch}, obj) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`/products/update/${obj.id}`, obj)
        .then((response) => {
          // commit('UPDATE_INVENTORY', response.data.data.products)
          dispatch('fetchProducts')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCourseList ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/courses/courseList')
        .then((response) => {
          // console.log('courselist to link in products', response.data.data)
          commit('SET_COURSELIST', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
